module.exports = __webpack_public_path__ + "img/Truppführer_LdF.0b5a8bce.svg";